import React, {Component} from 'react';
import '../../../Common/Common.css';
import './PCBQuotationForm.css';
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import PCBWithStencilForm from "./PCBWithStencilForm/PCBWithStencilForm";
import PCBQuotationImageUploader from './PCBQuotationImageUploader/PCBQuotationImageUploader';
import Layers from './PCBQuotationFormFields/Layers';
import Dimensions from "./PCBQuotationFormFields/Dimensions";
import PCBImpedance from './PCBQuotationFormFields/Impedance';
import PCBQuantity from "./PCBQuotationFormFields/PCBQuantity";
import PCBThickness from "./PCBQuotationFormFields/PCBThickness";
import PCBColor from "./PCBQuotationFormFields/PCBColor";
import SurfaceFinish from "./PCBQuotationFormFields/SurfaceFinish";
import CopperWeight from "./PCBQuotationFormFields/CopperWeight";
import PCBGoldFingers from "./PCBQuotationFormFields/PCBGoldFingers";
import MaterialDetails from "./PCBQuotationFormFields/MaterialDetails";
import FlyingProbeTest from "./PCBQuotationFormFields/FlyingProbeTest";
import CastellatedHoles from "./PCBQuotationFormFields/CastellatedHoles";
import DifferentDesign from "./PCBQuotationFormFields/DifferentDesign";
import PCBQuotationRemark from "./PCBQuotationFormFields/PCBQuotationRemark";
import PanelByJLCPCB from "./PCBQuotationFormFields/PanelByJLCPCB";
import PCBEdgeRails from "./PCBQuotationFormFields/EdgeRails";
import PanelSize from "./PCBQuotationFormFields/PanelSize";
import SilkColor from "./PCBQuotationFormFields/SilkColor";
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../InitialQuotationState";
import ContactUs from "../../SiteRoot/Navigation/ContactUs/ContactUs";
import EdgeQty from "./PCBQuotationFormFields/EdgeQty";
import PriceLoadingImage from "../../../../assets/img/loading_price.gif";
import MetaTags from "react-meta-tags";
import Modal from "react-bootstrap/lib/Modal";

// import SilkColor_1 from "./PCBQuotationFormFields/silkColor";

class PCBQuotationForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            showContactUs: false,
            orderType: 1,
            fileName: "",
            imageData: {
                fileUrl: "",
                id: -1,
                imageUrl: "",
                imageUrlBottom: "",
                imageUrlBottomEncoded: "",
                imageUrlTop: "",
                imageUrlTopEncoded: "",
                key: "",
                originalFileName: "",

            },
            errorResponse: '',
            showStencilForm: false,
            gerberReviewLayer: null,
            gerberReviewLength: null,
            gerberReviewWidth: null,
            gerberDivStyle: this.props.gerberDivStyle,
            gerberError: false,
            isGerberUploading: false,
            gerberUploadErrorMessage: ''

        };

        this.fileUploaderClicked = this.fileUploaderClicked.bind(this);
        this.launchFileUploader = this.launchFileUploader.bind(this);
        this.laserStencilClicked = this.laserStencilClicked.bind(this);
        this.getGerberReview = this.getGerberReview.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.validate = this.validate.bind(this);
        this.setGerberError = this.setGerberError.bind(this);
        this.unsetGerberError = this.unsetGerberError.bind(this);
    }

    setGerberError = (gerberUploadErrorMessage) => {
        this.setState({
            gerberError: true,
            gerberUploadErrorMessage
        })
    };
    unsetGerberError = () => {
        this.setState({
            gerberError: false,
            gerberUploadErrorMessage: ''
        })
    };
    validate = (value) => {

    }


    showContactForm = () => {
        this.setState({
            showContactUs: true
        })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            if (this.props.quotation.orderType === 2) {
                this.setState({
                    showStencilForm: true,
                    orderType: this.props.quotation.orderType,
                    imageData: this.props.gerberImageData,
                    gerberDivStyle: this.props.gerberDivStyle,
                    fileName: this.props.gerberImageData !== null ?
                        this.props.gerberImageData.originalFileName : ""
                });

                document.getElementById("pcbWithStencil").checked = true;
            } else {
                this.setState({
                    showStencilForm: false,
                    orderType: this.props.quotation.orderType,
                    imageData: this.props.gerberImageData,
                    gerberDivStyle: this.props.gerberDivStyle,
                    fileName: this.props.gerberImageData !== null ?
                        this.props.gerberImageData.originalFileName : ""
                });
            }
        }
        if (InitialQuotationState.quotationErrorMessage !== null) {
            // document.getElementById("uploader").disabled = true;
            // setTimeout(() => {
            //     document.getElementById("uploader").disabled = false;
            //     // document.body.removeChild(div);
            //
            // }, 60000)


            ////////////////
            // let div = document.createElement("div");
            // let img = document.createElement("img");
            // img.className = "loading-image-price center-img";
            // img.src = PriceLoadingImage;
            // img.alt = "Loading...";
            // div.appendChild(img);
            // div.className += "overlayfullscreen";
            // document.body.appendChild(div);
            ////////////////


        }
    }

    hideModal() {
        this.setState({
            modalShow: false,
        })
    }

    fileUploaderClicked = () => {

        let regEx = /^[\sa-zA-Z0-9_.-]*$/;
        let files = document.getElementById("uploader").files;
        console.log('uploader ===> ', files[0].name);
        if (regEx.test(files[0].name)) {
            this.setState({
                fileName: files[0].name,
                isGerberUploading: true
            });

            let priceInfoJson = {...this.props.quotation};

            /* remove unwanted properties */
            delete priceInfoJson.fileKey;
            delete priceInfoJson.smtStencilParam.framework;
            delete priceInfoJson.smtStencilParam.customizeSize;

            /* add additional properties */
            priceInfoJson.country = "HR";
            priceInfoJson.shippingMethod = "dhl";

            const formData = new FormData();
            formData.append('gerberFile', files[0]);
            formData.append('pricingRequest', JSON.stringify(priceInfoJson));

            this.props.setLoadingPriceOnOff(true);

            axios.post(RESOURCE_BASE_URL + 'api/gerber/uploadGerberFile', formData)
                .then((res) => {
                    console.log("GERBER IMAGE DATA DUO PCB =====> ", res.data);

                    if (res.data.message === "success") {
                        this.setState({
                            imageData: res.data.gerberDetails,
                            isGerberUploading: false
                        }, () => {
                            let quotationParams = res.data.quotationParams;
                            this.props.setPCBParamsWhenGerberUpload(0, {id: quotationParams.layer, name: "layer"});
                            this.props.setPCBParamsWhenGerberUpload(0, {id: quotationParams.width, name: "width"});
                            this.props.setPCBParamsWhenGerberUpload(0, {id: quotationParams.length, name: "length"});
                            this.props.setMainPriceInfo(res.data.mainPriceInfo);
                            this.props.setLoadingPriceOnOff(false);
                            this.props.setGerberImageData(res.data.gerberDetails);
                            InitialQuotationState.gerberFileKey = res.data.gerberDetails.key;
                            if (Object.keys(res.data).length === 0) {
                                this.setGerberError("ガーバーアップロードエラー。TOP画面からもう一度お試しください。");
                            }
                        });
                    } else if (res.data.message === "without_review") {
                        this.setState({
                            imageData: res.data.gerberDetails,
                            isGerberUploading: false
                        }, () => {
                            // let quotationParams = res.data.quotationParams;
                            this.props.setPCBParamsWhenGerberUpload(0, {id: 2, name: "layer"});
                            this.props.setPCBParamsWhenGerberUpload(0, {id: "", name: "width"});
                            this.props.setPCBParamsWhenGerberUpload(0, {id: "", name: "length"});
                            // this.props.setMainPriceInfo(res.data.mainPriceInfo);
                            this.props.setLoadingPriceOnOff(false);
                            this.props.setGerberImageData(res.data.gerberDetails);
                            InitialQuotationState.gerberFileKey = res.data.gerberDetails.key;
                            if (Object.keys(res.data).length === 0) {
                                this.setGerberError("ガーバーアップロードエラー。TOP画面からもう一度お試しください。");
                            }
                        });
                        localStorage.setItem("withoutResult", false);

                    } else if (res.data.message === "invalid_length_width") {
                        this.setState({
                            imageData: res.data.gerberDetails,
                            isGerberUploading: false
                        }, () => {
                            // let quotationParams = res.data.quotationParams;
                            this.props.setPCBParamsWhenGerberUpload(0, {id: 2, name: "layer"});
                            this.props.setPCBParamsWhenGerberUpload(0, {id: "", name: "width"});
                            this.props.setPCBParamsWhenGerberUpload(0, {id: "", name: "length"});
                            // this.props.setMainPriceInfo(res.data.mainPriceInfo);
                            this.props.setLoadingPriceOnOff(false);
                            this.props.setGerberImageData(res.data.gerberDetails);
                            InitialQuotationState.gerberFileKey = res.data.gerberDetails.key;
                            if (Object.keys(res.data).length === 0) {
                                this.setGerberError("ガーバーアップロードエラー。TOP画面からもう一度お試しください。");
                            }
                        });
                        localStorage.setItem("withoutResult", false);

                    } else if (res.data.message === "invalid_length") {
                        this.setGerberError("寸法はサポートされていません。PCBの長さは6〜500 mmにする必要があります。");
                        this.props.setLoadingPriceOnOff(false);
                        this.setState({
                            isGerberUploading: false
                        })
                    } else if (res.data.message === "invalid_width") {
                        this.setGerberError("寸法はサポートされていません。 PCB幅は6-400 mmの間でなければなりません。");
                        this.props.setLoadingPriceOnOff(false);
                        this.setState({
                            isGerberUploading: false
                        })
                    } else {
                        this.setGerberError("ガーバーアップロードエラー。TOP画面からもう一度お試しください。");
                        this.props.setLoadingPriceOnOff(false);
                        this.setState({
                            isGerberUploading: false
                        })
                    }

                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                    document.getElementById("uploader").disabled = true;

                    setTimeout(() => {
                        document.getElementById("uploader").disabled = false;

                    }, 60000);
                    this.setGerberError("ガーバーアップロードエラー。TOP画面からもう一度お試しください。");
                    this.props.setLoadingPriceOnOff(false);

                    this.setState({
                        isGerberUploading: false
                    })
                });

        } else {
            // document.getElementById("modalSpecialCharacters").style.display = "block";
            console.log("modalSpecialCharacters");
            this.setState({
                modalShow: true,
                isGerberUploading: false,
                fileName: ""
            },() => {
                document.getElementById("uploader").value = null;
            });
            console.log("fileName ====> ", this.state.fileName);
        }

    };

    getGerberReview = (key) => {

        let gerberReviewPostData = {
            language: 0,
            key: key
        };

        let axiosConfigForReview = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.post(RESOURCE_BASE_URL + 'api/jlcpcb/gerber/review', gerberReviewPostData, axiosConfigForReview)
            .then((res) => {

                this.setState({
                    gerberReviewLayer: res.data.result.stencilLayer,
                    gerberReviewLength: res.data.result.setLength,
                    gerberReviewWidth: res.data.result.setWidth
                })

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    launchFileUploader = () => {
        document.getElementById('uploader').click();
    };

    laserStencilClicked = (event) => {
        this.setState({
            showStencilForm: event.target.checked
        }, () => this.props.getPriceInfo);

        if (InitialQuotationState.qsdcls === "") {
            InitialQuotationState.qsdcls = 'pcb-quotation-sum-height';

        } else {
            InitialQuotationState.qsdcls = '';

        }

        this.props.pcbWithStencilFormActivated(event);
    };
    handleInput = (e) => {
        let reg = new RegExp('^[1-9]([0-9]*)(\.[0-9]{0,2})?$');
        let regGreater = /^[1-9]([0-9]*)(\.[0-9]{0,1})?$/;
        // let reg = new RegExp('^[1-9]([0-9]*)(\\.\\d{1,2})?$');
        if (e.target.value < 100) {
            if (!reg.test(e.target.value)) {
                e.target.value = "";
                e.target.placeholder = '0';
                return;
            }
        } else {
            if (!regGreater.test(e.target.value)) {
                e.target.value = "";
                e.target.placeholder = '0';
                return;
            }
        }

        this.props.setPCBParams({name: e.target.name, id: parseInt(e.target.value)});
    };

    render() {

        const displayStyle = {
            display: 'block'
        };

        let userId = null;

        if (this.props.userId !== undefined) {
            userId = this.props.userId;
        }

        return (
            <div className="pcb-quotation-div" style={displayStyle}>
                <MetaTags>
                    <title>まずは見積スタート！｜プリント基板製造サービス｜KITCUT PCB </title>
                    <meta property="title" content="まずは見積スタート！｜プリント基板製造サービス｜KITCUT PCB" lang="ja"/>
                    <meta name="title" content="まずは見積スタート！｜プリント基板製造サービス｜KITCUT PCB" lang="ja"/>
                    <meta property="description"
                          content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。"
                          lang="ja"/>
                    <meta name="description"
                          content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。"
                          lang="ja"/>
                </MetaTags>
                <div style={this.state.gerberDivStyle}>
                    <PCBQuotationImageUploader fileName={this.state.fileName}
                                               launchFileUploader={this.launchFileUploader}
                                               fileUploaderClicked={this.fileUploaderClicked}
                                               imageData={this.state.imageData}
                                               gerberDivStyle={this.state.gerberDivStyle}
                                               gerberError={this.state.gerberError}
                                               gerberUploadErrorMessage={this.state.gerberUploadErrorMessage}
                                               isGerberUploading={this.state.isGerberUploading}/>
                </div>
                <Layers setPCBParams={this.props.setPCBParams}
                        selectedId={this.state.gerberReviewLayer !== null ? this.state.gerberReviewLayer : this.props.quotation.pcbParam.layer}
                        pcbParams={this.props.quotation.pcbParam}/>

                <Dimensions setDimensions={this.props.setDimensions}
                            selectedWidth={this.state.gerberReviewWidth !== null ? this.state.gerberReviewWidth : this.props.quotation.pcbParam.width}
                            selectedLength={this.state.gerberReviewLength !== null ? this.state.gerberReviewLength : this.props.quotation.pcbParam.length}
                            pcbParams={this.props.quotation.pcbParam}
                />

                <DifferentDesign setPCBParams={this.props.setPCBParams}
                                 selectedId={this.props.quotation.pcbParam.differentDesign}
                                 setDifferentDesign={this.props.setDifferentDesign}/>

                <PCBQuantity setQuantity={this.props.setQuantity}
                             selectedQty={this.props.quotation.pcbParam.qty}
                             setPCBQuantity={this.props.setPCBQuantity}/>

                <PCBThickness setPCBParams={this.props.setPCBParams}
                              selectedId={this.props.quotation.pcbParam.thickness}
                              panelFlag={this.props.quotation.pcbParam.panelFlag}
                              pcbParam={this.props.quotation.pcbParam}
                />

                {this.props.quotation.pcbParam.layer > 3 ?

                    <PCBImpedance setPCBParams={this.props.setPCBParams}
                                  selectedId={this.props.quotation.pcbParam.impedance}
                                  selectedIdLayer={this.state.gerberReviewLayer !== null ? this.state.gerberReviewLayer : this.props.quotation.pcbParam.layer}
                    /> : ''
                }

                <PCBColor setPCBParams={this.props.setPCBParams}
                          selectedId={this.props.quotation.pcbParam.pcbColor}
                          pcbParams={this.props.quotation.pcbParam}/>


                <SilkColor setPCBParams={this.props.setPCBParams}
                           selectedIdLayer={this.props.quotation.pcbParam.pcbColor}
                           selectedId={this.props.quotation.pcbParam.silkColor}
                           pcbParams={this.props.quotation.pcbParam}/>

                <SurfaceFinish setPCBParams={this.props.setPCBParams}
                               selectedId={this.props.quotation.pcbParam.surfaceFinish}
                               pcbParams={this.props.quotation.pcbParam}/>

                <CopperWeight setPCBParams={this.props.setPCBParams}
                              selectedId={this.props.quotation.pcbParam.copperWeight}
                              pcbParams={this.props.quotation.pcbParam}/>

                <PCBGoldFingers setPCBParams={this.props.setPCBParams}
                                selectedId={this.props.quotation.pcbParam.goldFinger}/>

                <MaterialDetails setPCBParams={this.props.setPCBParams}
                                 selectedId={this.props.quotation.pcbParam.materialDetails}/>

                <PanelByJLCPCB setPCBParams={this.props.setPCBParams}
                               selectedId={this.props.quotation.pcbParam.panelFlag}
                               selectedSizeX={this.props.quotation.pcbParam.width}
                               panelByJLCPCB_X={this.props.quotation.pcbParam.panelByJLCPCB_X}
                               selectedSizeY={this.props.quotation.pcbParam.length}
                               thickness={this.props.quotation.pcbParam.thickness}
                               panelByJLCPCB_Y={this.props.quotation.pcbParam.panelByJLCPCB_Y}
                               handleInput={this.handleInput}
                               pcbParam={this.props.quotation.pcbParam}
                />

                {this.props.quotation.pcbParam.panelFlag === 1 ?

                    <PCBEdgeRails setPCBParams={this.props.setPCBParams}
                                  selectedId={this.props.quotation.pcbParam.edgeRails}/> : ''
                }
                {this.props.quotation.pcbParam.panelFlag === 1 ?

                    <PanelSize handleInput={this.handleInput} pcbParam={this.props.quotation.pcbParam}/> : ''
                }

                <FlyingProbeTest setPCBParams={this.props.setPCBParams}
                                 selectedId={this.props.quotation.pcbParam.flyingProbe}/>


                <CastellatedHoles setPCBParams={this.props.setPCBParams}
                                  selectedId={this.props.quotation.pcbParam.castellatedHoles}/>

                {this.props.quotation.pcbParam.castellatedHoles >= 1 ?
                    <EdgeQty setPCBParams={this.props.setPCBParams}
                             selectedId={1}/> : ''
                }

                <PCBQuotationRemark setRemarks={this.props.setRemarks}
                                    remarks={this.props.quotation.pcbParam.orderDetailsRemark}/>

                {!this.props.editMode ?

                    <div className="pcb-with-stencil-checkbox">
                        <input type="checkbox" id="pcbWithStencil"
                               onChange={this.laserStencilClicked}/>
                        &nbsp;
                        <FormattedMessage id="app.pcb-quotation.stencil-checkbox"
                                          defaultMessage="SMT metal mask: Order SMT metal mask together"
                                          description=""/>

                    </div> : ""
                }

                {this.state.showStencilForm ?
                    <PCBWithStencilForm
                        setStencilParams={this.props.setStencilParams}
                        setDimensions={this.props.setDimensions}
                        setQuantity={this.props.setQuantity}
                        setRemarks={this.props.setRemarks}
                        showStencilWithPCB={this.props.showStencilWithPCB}
                        quotation={this.props.quotation}
                    />
                    :
                    null
                }


                <div className="pcb-with-stencil-msg-div">

                    <ul>
                        <li><FormattedMessage id="app.pcb-quotation.msg-1"
                                              defaultMessage="サポートが必要な方は,"
                                              description=""/>
                            <ContactUs quo={true} userId={userId}/>
                        </li>
                        <li><FormattedMessage id="app.pcb-quotation.msg-2"
                                              defaultMessage="ご注文の前には必ずガーバーファイルを確認してください。"
                                              description=""/></li>
                        <li><FormattedMessage id="app.pcb-quotation.msg-3"
                                              defaultMessage="注文方法についてはkitcutpcbの注文方法を参照してください。"
                                              description=""/></li>
                    </ul>
                </div>

                {/*{---popup-modal-special-characters---}*/}
                <Modal dialogClassName="special-character-modal modal-center1" show={this.state.modalShow}>
                    <Modal.Body class="modal-body">
                            <div className="row">
                                <div className="modal-dialog center">
                                    ファイル名に次の文字はご利用できません。<br/>
                                    “ひらがな”、“カタカナ”、“特殊文字”
                                </div>
                            </div>
                    </Modal.Body>
                    <Modal.Footer class="modal-footer">
                            <button className="btn btn-success col-md-2 pull-right delete-btn-yes btn-align"
                                    onClick={() => this.hideModal()}>
                                <FormattedMessage id="app.modal.close"
                                                  defaultMessage="No"
                                                  description=""/>
                            </button>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }
}

export default PCBQuotationForm;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationForm.js